import { S } from '../regureStyles';

const Tabs = ({ tabs, activeTab, setActiveTab }) => {
  return (
    <div style={{ display: 'flex', gap: 0, borderBottom: `2px solid ${S.borderLight}`, marginBottom: 28 }}>
      {tabs.map(tab => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          style={{
            padding: '10px 24px',
            border: 'none',
            background: 'none',
            cursor: 'pointer',
            fontSize: 14,
            fontWeight: activeTab === tab.id ? 600 : 400,
            color: activeTab === tab.id ? S.burgundy : S.textSecondary,
            borderBottom: activeTab === tab.id ? `2px solid ${S.burgundy}` : '2px solid transparent',
            marginBottom: -2,
            transition: 'all 0.15s',
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
